export default __webpack_public_path__ + "assets/c7eddf4a70cb416cc776a328447ac5ce.svg";